import React from "react";
import GradientBackground from "./GradientBackground";

const HeroSection: React.FC = () => {
  const scrollToProducts = () => {
    const element = document.getElementById("products");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center bg-white"
    >
      <GradientBackground />

      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-brand-text mb-6 leading-tight">
          打造精致的
          <br />
          <span className="text-brand-text-secondary">效率工具</span>
        </h1>

        <p className="text-lg sm:text-xl text-brand-text-secondary mb-10 max-w-2xl mx-auto leading-relaxed">
          嘉屹软件开发工作室，专注于创造简洁、高效、优雅的应用程序，
          让科技真正服务于生活。
        </p>

        <button
          onClick={scrollToProducts}
          className="inline-flex items-center gap-2 px-8 py-4 bg-brand-accent text-white rounded-full
                     hover:bg-brand-accent-hover transition-all duration-300 hover:scale-105
                     text-base font-medium"
        >
          探索产品
          <svg
            className="w-4 h-4 animate-scroll-hint"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </button>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-gray-300 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-gray-400 rounded-full mt-2 animate-scroll-hint" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
